import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

interface LogoProps {
  variant?: 'horizontal' | 'compact' | 'stacked';
  className?: string;
  showSlogan?: boolean;
}

export default function Logo({
  variant = 'horizontal',
  className = '',
  showSlogan = false,
}: LogoProps) {
  return (
    <Link
      href="/"
      className={`group inline-flex items-center gap-3 transition-opacity hover:opacity-90 ${className}`}
      aria-label="Evergreen Strategy Home"
    >
      <div className="relative flex-shrink-0 flex items-center justify-center">
        <Image
          src="/images/logo/evergreen-tree-mark.png"
          alt="Evergreen Strategy Tree Mark"
          width={36}
          height={44}
          priority
          className="h-9 w-auto object-contain transition-transform duration-200 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col justify-center">
        <span className="font-bold tracking-[0.18em] text-[#1a2332] text-sm sm:text-base uppercase leading-tight font-sans">
          Evergreen Strategy
        </span>
        {showSlogan && (
          <span className="text-xs text-[#5a6577] font-medium tracking-normal mt-0.5 hidden sm:inline-block">
            Principal-level engineering, taught clearly.
          </span>
        )}
      </div>
    </Link>
  );
}
